import { render, staticRenderFns } from "./BaseProductTileSizeSelector.vue?vue&type=template&id=5027ebff&"
import script from "./BaseProductTileSizeSelector.vue?vue&type=script&lang=js&"
export * from "./BaseProductTileSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5027ebff')) {
      api.createRecord('5027ebff', component.options)
    } else {
      api.reload('5027ebff', component.options)
    }
    module.hot.accept("./BaseProductTileSizeSelector.vue?vue&type=template&id=5027ebff&", function () {
      api.rerender('5027ebff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductTileSizeSelector.vue"
export default component.exports